import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import FormContainer from "../Content";
import FormContainerChangePassword from "./ChangePassword";

interface TabNavigationProps {
    validated: boolean;
    requiredData: any;
    isOwnProfile: boolean;
    mergeUser: Function;
    mergeUserPassword: Function;
}

const TabNavigation = ({ validated, requiredData, isOwnProfile, mergeUser, mergeUserPassword }: TabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin tài thoản",
            labelEN: "info",
            content: (
                <FormContainer
                    validated={validated}
                    requiredData={requiredData}
                    isOwnProfile={isOwnProfile}
                    mergeUser={mergeUser}
                />
            ),
        },
        ...(isOwnProfile ? [{
            label: "Thay đổi mật khẩu",
            labelEN: "change-password",
            content: (
                <FormContainerChangePassword
                    validated={validated}
                    requiredData={requiredData}
                    isOwnProfile={isOwnProfile}
                    mergeUserPassword={mergeUserPassword}
                />
            ),
        }] : [])
    ];

    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
